import * as React from "react";

import s from "./AlarmComponent.module.scss";
import * as Assets from "../../assets";
import { Alarm } from "../../models";
import ClearAlarmDialog from "./ClearAlarmDialog";
import * as Utils from "../../utils";

interface IAlarmProps {
	alarm: Alarm;
	displayActions?: boolean;
	submitAlarm?: (alarm: Alarm, reason: string) => Promise<void>;
	submitReason?: (alarm: Alarm, reason: string) => Promise<void>;
	isClearAll?: boolean;
	clearAllReason?: string;
}

export const AlarmComponent = ({ alarm, displayActions, submitAlarm, submitReason, isClearAll, clearAllReason }: IAlarmProps): JSX.Element => {
	const [isOpenDialog, setIsOpenDialog] = React.useState<boolean>(false);
	const [clearing, setClearing] = React.useState<boolean>(false);

	const onClickClearHandler = (event: React.MouseEvent<HTMLButtonElement>): void => {
		event.preventDefault();
		setIsOpenDialog(true);
	};

	const submitAlarmFunc = (reason: string): void => {
		setIsOpenDialog(false);
		if (submitAlarm) {
			void submitAlarm(alarm, reason).then(() => setClearing(false));
			setClearing(true);
		}
	};

	React.useEffect((): void => {
		if (isClearAll && submitAlarm) {
			setClearing(true);
			void submitAlarm(alarm, clearAllReason || "").then(() => {
				setClearing(false);
			});
		}
	}, [isClearAll, clearAllReason, submitAlarm, alarm]);

	const submitReasonFunc = (reason: string): void => {
		setIsOpenDialog(false);
		if (submitReason) {
			void submitReason(alarm, reason).then(() => setClearing(false));
			setClearing(true);
		}
	};

	return (
		<div className={s.alarm}>
			{isOpenDialog && (
				<ClearAlarmDialog isOpen={isOpenDialog}
					alarm={alarm}
					cancel={() => setIsOpenDialog(false)}
					submitAlarm={submitAlarmFunc}
					submitReason={submitReasonFunc} />
			)}
			<div className={s.alarm__row}>
				<div className={s.alarm__icon}>
					<img alt={""} src={Utils.getIconSrc(alarm)} />
				</div>
				<div className={[s.alarm__info, s.info].join(" ")}>
					<div className={s.info__column}>
						<div className={[s.info__item, s.item].join(" ")}>
							<div className={s.item__row}>
								<div className={s.item__label}>Original:</div>
								<div className={s.item__date}>{Utils.time.format(alarm.timestamp, "D MMMM YYYY HH:mm:ss")}</div>
								<div className={s.item__sensor}>{alarm.displayName}</div>
							</div>
						</div>
						{!!alarm.clearedBy && (
							<div className={[s.info__item, s.item].join(" ")}>
								<div className={s.item__row}>
									<div className={s.item__label}>Cleared:</div>
									<div className={s.item__date}>{Utils.time.format(alarm.clearedTimestamp, "D MMMM YYYY HH:mm:ss")}</div>
									<div className={s.item__clearedBy}>{alarm.clearedBy}</div>
								</div>
							</div>
						)}
						{!!alarm.clearedBy && (
							<div className={[s.info__item, s.item].join(" ")}>
								<div className={s.item__row}>
									<div className={s.item__label}>Reason:</div>
									<div className={s.item__text}>{alarm.reason}</div>
								</div>
							</div>
						)}
					</div>
				</div>
				{displayActions && !clearing && (
					<button onClick={(onClickClearHandler)}>{!alarm.clearedBy ? "Clear" : "Edit"}</button>)}
				{displayActions && clearing && (
					<div className={s.alarm__iconLoading}><img alt={"download/loading"} src={Assets.Load} /></div>)}
			</div>
		</div>
	);
};
